export default __webpack_public_path__ + "static/media/view-board.bb114e23.svg";